import { useEffect, useState } from 'react';
import TutorSingleQuestionPage from './Quiz/TutorSingleQuestionPage/TutorSingleQuestionPage';
import ReactPlayer from 'react-player';
import '../LessonViewFocusLayout.css';

function TutorHomePageV2({ studentState, studentInput, isFocused = false }) {
    const [currentStep, setCurrentStep] = useState(null);
    const [latestLesson, setLatestLesson] = useState(null);

    useEffect(() => {
        setCurrentStep(studentState?.currentStep);
    }, [studentState?.currentStep]);

    useEffect(() => {
        setLatestLesson(studentState?.latestLesson);
    }, [studentState?.latestLesson]);

    return (
    <>          
            {latestLesson?.steps[currentStep]?.Type?.includes('Question') ? (
                <TutorSingleQuestionPage 
                    quizQuestion={latestLesson?.steps[currentStep]?.quizQuestionId}
                    ButtonsAreClickable={false}
                    onAnswerSelect={() => {}}
                    studentInput={studentInput}
                    isFocused={isFocused}
                />
            ) : isFocused ? (
                /* Focus mode: same DOM structure and shared layout as student (LessonViewFocusLayout.css) */
                <div className="lesson-view-focus lesson-view-focus--fill relative">
                    <div className="lesson-view-focus__video">
                        <div className="lesson-view-focus__video-inner">
                            <ReactPlayer
                                url={latestLesson?.steps[currentStep]?.animation}
                                controls={true}
                                width="100%"
                                height="100%"
                                style={{ maxHeight: '100%' }}
                            />
                        </div>
                    </div>
                    <div className="lesson-view-focus__talking-point">
                        <h3 className="lesson-view-focus__talking-point-heading">Addy&apos;s Response:</h3>
                        <p className="lesson-view-focus__talking-point-text">
                            {latestLesson?.steps[currentStep]?.TalkingPoint}
                        </p>
                    </div>
                </div>
            ) : (
                <div className="relative flex flex-col h-full w-full">
                    <div className="w-full p-2 bg-slate-300 shadow-lg border-2 border-black rounded-lg mb-2 flex justify-center items-center h-[75%]">
                        <div className="w-full h-full flex items-center justify-center">
                            <ReactPlayer
                                url={latestLesson?.steps[currentStep]?.animation}
                                controls={true}
                                width="100%"
                                height="100%"
                                style={{ maxHeight: '100%' }}
                            />
                        </div>
                    </div>
                    <div className="w-full p-2 bg-slate-300 shadow-lg border-2 border-black rounded-lg overflow-y-auto h-[20%]">
                        <p className="text-sm text-gray-700 whitespace-pre-wrap text-center">
                            {latestLesson?.steps[currentStep]?.TalkingPoint}
                        </p>
                    </div>
                </div>
            )}
        </>
    );
}

export default TutorHomePageV2;